import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/shared/localstorage.service';
import { parseImportFilterRequest, refillImportsFilter } from 'src/app/shared/utils/helpers';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { IImportFilter } from '../../models/imports.models';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-import-filter',
  templateUrl: './import-filter.component.html',
  styleUrls: ['./import-filter.component.scss']
})
export class ImportFilterComponent implements OnInit {

   readonly separatorKeysCodes = [ENTER, COMMA] as const;

    currentFilter: Observable<IImportFilter> = this.store.select(
      (state) => state.importProducts.ImportFilterState.advanced
    );
    importFilter = LocalStorageService.get('importFilter');

    selectedGroup = 'import_info';

    filter: IImportFilter= refillImportsFilter()
    filterName = '';
    toggleSaveFilterForm = false;
    filterNameControl = new FormControl('', Validators.required);
    constructor(
      public dialogRef: MatDialogRef<ImportFilterComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private store: Store<AppState>
    ) { }

    ngOnInit(): void {
      this.currentFilter.subscribe((filter: IImportFilter) => {
        this.filter = refillImportsFilter(filter);
      });
    }

    getFiltersCount(): number {
      return parseImportFilterRequest(this.filter)?.filters?.length || 0;
    }

    close(): void {
      this.dialogRef.close();
    }

    clearFilters(): void {
      this.filter = refillImportsFilter();
      this.filterName = '';
    }

    toggleSaveFilter(): void {
      this.toggleSaveFilterForm = !this.toggleSaveFilterForm;
    }

    save(): boolean | void {
      if(!this.filterNameControl.valid){
        this.filterNameControl.markAsTouched();
        return false
      }
      if (!this.importFilter?.filters)
        this.importFilter = {
          filters: [{ name: this.filterName, filter: this.filter }],
        };
      else {
        const filter = this.importFilter.filters?.find(
          (f: any) => f.name.toLowerCase() === this.filterName.toLowerCase()
        );
        if (filter)
          this.importFilter.filters = this.importFilter.filters?.map((f: any) => {
            if (f.name === this.filterName) return { name: this.filterName, filter: this.filter };
            return f;
          });
        else
          this.importFilter.filters.push({
            name: this.filterName,
            filter: this.filter,
          });
      }
      LocalStorageService.put('importFilter', this.importFilter);
      this.toggleSaveFilter();
    }

    setFilter(filter: any): void {
      if(filter){
        this.filterName = filter.name;
        this.filter = refillImportsFilter(filter.filter);
      }
    }


    deleteFilter(filter: any): void {
      this.importFilter.filters = this.importFilter.filters?.filter(
        (f: any) => f.name !== filter.name
      );
      LocalStorageService.put('importFilter', this.importFilter);
    }

    apply(): void {
      this.dialogRef.close(this.filter);
    }
  }
